module.exports = __webpack_public_path__ + "static/media/menuIcon.aa99ee06.svg";